import LocalidadesForm from "./LocalidadesForm";
export default LocalidadesForm;